/* eslint-disable camelcase */

interface Event {
  amp_event_name: string;
  e_action: string;
  e_category: string;
  event: string;
  event_trigger: string;
  is_sponsored: boolean;
  tipsheet_url?: string;
}

export class Events {
  static clickCard(context: {
    pageType?: string;
    url: string;
    isSponsored: boolean;
  }): Event {
    const { pageType, url, isSponsored } = context;
    return {
      amp_event_name: 'Click on tipsheet card',
      e_action: 'Click on tipsheet card',
      e_category: 'tipsheet',
      event: 'interaction_click on tipsheet card',
      event_trigger: `%${pageType}_page%`,
      tipsheet_url: url,
      is_sponsored: isSponsored,
    };
  }

  static viewCard(context: { pageType?: string; isSponsored: boolean }): Event {
    const { pageType, isSponsored } = context;
    return {
      amp_event_name: 'Display tipsheet card',
      e_action: 'Display tipsheet card',
      e_category: 'advice',
      event: 'interaction_display tipsheet card',
      event_trigger: `%${pageType}_page%`,
      is_sponsored: isSponsored,
    };
  }
}
